import { appWithTranslation } from 'next-i18next';
import '../styles/globals.scss';
import '../styles/header.scss';
import '../styles/main.scss';
import '../styles/footer.scss';
import '../styles/contactUsModal.scss';
import '../styles/info_section.scss';
import '../styles/service.scss';
import '../styles/related_serivces.scss';

function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />
}

export default appWithTranslation(MyApp);
